export default __webpack_public_path__ + "static/media/img-2.256ed424.jpg";